// A steady colour per person, Slack-style: the same name always gets the same
// one, so a sender is easy to pick out down a thread. Chakra colour names, kept to the turquoise / royal / navy family.
const PALETTE = ["teal", "cyan", "blue", "purple"];

export function userColor(name) {
  let h = 0;
  for (const ch of String(name || "?")) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
